import { useStaticQuery, graphql } from 'gatsby'

export const getSymposiumSeriesData = () => {
  const { allStrapiSymposiumSeries } = useStaticQuery(symposiumSeriesDataQuery)
  return allStrapiSymposiumSeries.nodes
}

const symposiumSeriesDataQuery = graphql`
  query {
    allStrapiSymposiumSeries(sort: {fields: date, order: DESC}) {
      nodes {
        title
        slug
        excerpt: body {
          data {
            excerpt: body
          }
        }
        featuredImage {
          ImageSharp_vertical: localFileImageSharp {
            gatsbyImageData(width: 300, height: 470)
          }
        }
        button {
          url
          name
          id
        }
      }
    }
  }
`
